<div class="isg-authtree-wrapper">

  <div class="isg-authtree-toolbar">

    <button kendoButton type="button" class="isg-button-icon" (click)="onToggle()">
      <span class="fa-solid fa-up-right-and-down-left-from-center" title="Expand/Collapse"></span>
    </button>

    <button *ngIf="showSaveButton" kendoButton type="button" class="isg-button-icon" (click)="onSaveClick()" [disabled]="!enableSaveButton">
      <span class="fas fa-save" title="Save"></span>
    </button>

    <button *ngIf="showCreateButton" kendoButton type="button" class="isg-button-icon" (click)="onAddClick()" [disabled]="!selectedItem">
      <span class="fas fa-plus" title="Create a new permission"></span>
    </button>

    <button *ngIf="showEditButton" kendoButton type="button" class="isg-button-icon" (click)="onEditClick()" [disabled]="!selectedItem">
      <span class="fas fa-pencil" title="Edit the selected permission"></span>
    </button>

    <button *ngIf="showReadOnlyButton" kendoButton type="button" class="isg-button-icon" (click)="onViewClick()" [disabled]="!selectedItem">
      <span class="fas fa-magnifying-glass" title="Detail"></span>
    </button>

    <button *ngIf="showReorderButton" kendoButton type="button" class="isg-button-icon" (click)="onMoveItem('up')" [disabled]="!selectedItem">
      <span class="fa-solid fa-arrow-up" title="Move Up"></span>
    </button>

    <button *ngIf="showReorderButton" kendoButton type="button" class="isg-button-icon" (click)="onMoveItem('down')" [disabled]="!selectedItem">
      <span class="fa-solid fa-arrow-down" title="Move Down"></span>
    </button>

    <button *ngIf="showDeleteButton" kendoButton type="button" class="isg-button-icon" (click)="onDeleteClick()" [disabled]="!selectedItem">
      <span class="fas fa-trash" title="Delete the selected permission"></span>
    </button>

  </div>
  <div class="isg-authtree-message">{{messageInfo}}</div>
  <div class="isg-authtreeview-wrapper">

    <kendo-treeview kendoTreeViewSelectable
                    kendoTreeViewCheckable
                    kendoTreeViewExpandable
                    kendoTreeViewHierarchyBinding
                    textField="text"
                    childrenField="items"
                    [selectBy]="key"
                    [expandBy]="'text'"
                    [checkBy]="key"
                    [isChecked]="isChecked"
                    [nodes]="dataItems"
                    [animate]="false"
                    [loadOnDemand]="false"
                    [style.height.px]="heightTree"
                    (checkedChange)="onItemChecking($event)"
                    (selectionChange)="onSelectionChange($event)"
                    [(selectedKeys)]="selectedKeys"
                    [(checkedKeys)]="checkedKeys"
                    [(expandedKeys)]="expandedKeys">

      <ng-template kendoTreeViewNodeTemplate let-dataItem>
        <span [ngClass]="getCssClass(dataItem)">{{ dataItem.text }}</span>
      </ng-template>

    </kendo-treeview>

    <app-auth-tree-editor *ngIf="editDataItem"
                          [isViewOnlyEditor]="isViewOnlyEditor"
                          [editDataItem]="editDataItem"
                          (save)="onSaveEditor($event)"
                          (cancel)="onCancelEditor()">
    </app-auth-tree-editor>

  </div>
</div>
